module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "IVPcenter"
  }), _vm._v(" "), _c('p', {
    staticClass: "dedication sgc-2"
  }, [_c('span', {
    staticClass: "char-style-override-1 sgc-1"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication-verse para-style-override-9 sgc-3"
  }, [_vm._v("To the missional leaders in the Ecclesia Network your faith, hope and love inspire me. Your willingness to explore new ways to be the church with a focus on making disciples of Jesus, through the power of the Spirit to the glory of God and for the good of the world, brings great encouragement to my heart.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d071e90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedication.vue
// module id = 57
// module chunks = 0